import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {AuthProvider, DarkModeProvider, PahoProvider} from "./context";
import {HeaderBootstrap, MainBootstrap, FooterBootstrap} from "./layout";
import "bootstrap-icons/font/bootstrap-icons.min.css"

import "./css/bootstrap.min.css";
import './css/custom.scss';
import "./css/bootstrap.custom.css"
import {CookieProvider} from "./layout/cookie/Cookie";


function App() {

    return (
        <BrowserRouter>
            <CookieProvider>
                <AuthProvider>
                    {/*<PahoProvider>*/}
                        <DarkModeProvider>
                            <HeaderBootstrap/>
                            <MainBootstrap/>
                            <FooterBootstrap/>
                        </DarkModeProvider>
                    {/*</PahoProvider>*/}
                </AuthProvider>
            </CookieProvider>
        </BrowserRouter>
    )
}


export default App;
